import portfolioImg1 from "../assets/images/projects/portfolio/Portfolio_1.png";
import portfolioImg2 from "../assets/images/projects/portfolio/Portfolio_2.png";
import portfolioImg3 from "../assets/images/projects/portfolio/Portfolio_3.png";
import boutiqueFrImg from "../assets/images/projects/boutique-fr/boutique-fr.png";
import ptutImg from "../assets/images/projects/ptut/ptut.png";
import automataImg from "../assets/images/projects/automata/automata.png";
import connect4Img from "../assets/images/projects/connect4/connect4.png";
import sokobanImg from "../assets/images/projects/sokoban/sokoban.png";
import metaheuristicImg from "../assets/images/projects/metaheuristic/metaheuristic.png";
import elkDashboard from "../assets/images/projects/siem-ids/kibana-dashboard.png";
import elkScenario from "../assets/images/projects/siem-ids/kibana-scenario.png";
import profilageArp from "../assets/images/projects/Profilage/arp_wireshark.png";
import profilageCapture from "../assets/images/projects/Profilage/capture_paquets.png";
import owaspA03 from "../assets/images/projects/Owasp/A03_admin_page.png";
import owaspA04 from "../assets/images/projects/Owasp/A04_1.png";
import vulnDocker1 from "../assets/images/projects/vulnhub/docker_1.png";
import vulnDocker2 from "../assets/images/projects/vulnhub/docker_2.png";
import vulnJetty1 from "../assets/images/projects/vulnhub/jetty_1.png";
import vulnJetty2 from "../assets/images/projects/vulnhub/jetty_2.png";
import forensicArchi from "../assets/images/projects/forensic/archi.png";
import forensicAutopsy from "../assets/images/projects/forensic/autopsy.png";
import forensicImages from "../assets/images/projects/forensic/images_autopsy.png";
import forensicScreen from "../assets/images/projects/forensic/screen_autopsy.png";

const projectsData = [
  {
    id: "Elk",
    route: "/Elk",
    titleKey: "projecttitle7",
    descriptionKey: "project7",

    techs: "Suricata ELK Bash Python",
    categories: ["Cyber"],
    github: null,
    image: elkDashboard,
    images: [elkDashboard, elkScenario],
    year: "2025",
    languages: ["Bash", "Python"],
    tools: ["Suricata", "syslog-ng", "Elasticsearch", "Kibana", "Slack Webhooks"],
    team: [
      { name: "Julien Larzul", github: "https://github.com/julienlrzl" },
    ],
    rightTitleKey: "titlerightE0",
    rightTextKey: "textrightE0",
    rightTitle1Key: "titlerightE1",
    rightText1Key: "textrightE1",
  },
  {
    id: "Vulnhub",
    route: "/Vulnhub",
    titleKey: "projecttitle8",
    descriptionKey: "project8",
    techs: "Docker Jetty Bash",
    categories: ["Cyber"],
    github: null,
    image: vulnDocker1,
    images: [vulnDocker1, vulnDocker2, vulnJetty1, vulnJetty2],
    year: "2025",
    languages: ["Bash"],
    tools: ["Docker", "Vulhub", "Jetty", "cURL"],
    team: [
      { name: "Julien Larzul", github: "https://github.com/julienlrzl" },
    ],
    rightTitleKey: "titlerightV0",
    rightTextKey: "textrightV0",
    rightTitle1Key: "titlerightV1",
    rightText1Key: "textrightV1",
  },
  {
    id: "Forensic",
    route: "/Forensic",
    titleKey: "projecttitle9",
    descriptionKey: "project9",
    techs: "Autopsy SQLite ALEAPP",
    categories: ["Cyber"],
    github: null,
    image: forensicAutopsy,
    images: [forensicAutopsy, forensicArchi, forensicImages, forensicScreen],
    carouselFit: "contain",
    year: "2025",
    languages: ["SQL"],
    tools: ["Autopsy", "DB Browser for SQLite", "ALEAPP"],
    team: [
      { name: "Julien Larzul", github: "https://github.com/julienlrzl" },
    ],
    rightTitleKey: "titlerightF0",
    rightTextKey: "textrightF0",
    rightTitle1Key: "titlerightF1",
    rightText1Key: "textrightF1",
  },
  {
    id: "Profilage",
    route: "/Profilage",
    titleKey: "projecttitle11",
    descriptionKey: "project11",
    techs: "Wireshark Nmap Kali SentinelC",
    categories: ["Cyber"],
    github: null,
    image: profilageCapture,
    images: [profilageCapture, profilageArp],
    carouselFit: "contain",
    year: "2025",
    languages: ["Bash"],
    tools: ["SentinelC", "Wireshark", "Nmap", "Gobuster", "Nikto", "Kali Linux"],
    team: [
      { name: "Julien Larzul", github: "https://github.com/julienlrzl" },
    ],
    rightTitleKey: "titlerightPr0",
    rightTextKey: "textrightPr0",
    rightTitle1Key: "titlerightPr1",
    rightText1Key: "textrightPr1",
  },
  {
    id: "Owasp",
    route: "/Owasp",
    titleKey: "projecttitle10",
    descriptionKey: "project10",
    techs: "ZAP PHP Node.js SQL",
    categories: ["Cyber"],
    github: null,
    image: owaspA03,
    images: [owaspA03, owaspA04],
    carouselFit: "contain",
    year: "2025",
    languages: ["PHP", "Node.js", "SQL"],
    tools: ["OWASP ZAP", "DVWA", "bWAPP", "WebGoat", "Juice Shop"],
    team: [
      { name: "Julien Larzul", github: "https://github.com/julienlrzl" },
    ],
    rightTitleKey: "titlerightO0",
    rightTextKey: "textrightO0",
    rightTitle1Key: "titlerightO1",
    rightText1Key: "textrightO1",
  },
  {
    id: "Metaheuristic",
    route: "/Metaheuristic",
    titleKey: "projecttitle6",
    descriptionKey: "project6",
    techs: "Python",
    categories: ["Python", "IA"],
    github: "https://github.com/julienlrzl/Projet_Metaheuristiques",
    image: metaheuristicImg,
    year: "2025",
    languages: ["Python"],
    tools: ["Git"],
    team: [
      { name: "Julien Larzul", github: "https://github.com/julienlrzl" },
      { name: "Victor Lefevre", github: "https://github.com/Victoooooooor" },
    ],
    rightTitleKey: "titlerightM0",
    rightTextKey: "textrightM0",
    rightTitle1Key: "titleright1",
    rightText1Key: "textrightM1",
  },
  {
    id: "Portfoliojulien",
    route: "/Portfoliojulien",
    titleKey: "projecttitle0",
    descriptionKey: "project0",
    techs: "React.js SCSS",
    categories: ["Web"],
    github: "https://github.com/julienlrzl/Portfolio",
    image: portfolioImg1,
    images: [portfolioImg1, portfolioImg2, portfolioImg3],
    year: "2024",
    languages: ["HTML", "SCSS", "Javascript"],
    tools: ["React.js", "Git"],
    team: [
      { name: "Julien Larzul", github: "https://github.com/julienlrzl" },
    ],
    rightTitleKey: "titleright0",
    rightTextKey: "textright0",
    rightTitle1Key: "titleright1",
    rightText1Key: "textright1",
  },
  {
    id: "BoutiqueFr",
    route: "/BoutiqueFr",
    titleKey: "projecttitle1",
    descriptionKey: "project1",
    techs: "PHP Twig JavaScript",
    categories: ["Web"],
    github: "https://github.com/julienlrzl/PHP_E_Boutique",
    image: boutiqueFrImg,
    year: "2024",
    languages: ["HTML", "CSS", "Javascript", "PHP"],
    tools: ["twig", "Git"],
    team: [
      { name: "Julien Larzul", github: "https://github.com/julienlrzl" },
      { name: "Albin Martin", github: "https://github.com/Albin0903" },
      { name: "Salim Lazrak", github: "https://github.com/saliml02" },
    ],
    rightTitleKey: "titlerightB0",
    rightTextKey: "textrightB0",
    rightTitle1Key: "titleright1",
    rightText1Key: "textrightB1",
  },
  {
    id: "Automata",
    route: "/Automata",
    titleKey: "projecttitle3",
    descriptionKey: "project3",
    techs: "Java",
    categories: ["Java"],
    github: "https://github.com/julienlrzl/Projet-Java-Automates",
    image: automataImg,
    year: "2024",
    languages: ["Java"],
    tools: ["Git"],
    team: [
      { name: "Julien Larzul", github: "https://github.com/julienlrzl" },
      { name: "Cédric Momprivé", github: "https://github.com/Majriche" },
      { name: "Tom Toupence", github: "https://github.com/Freedqumm" },
    ],
    rightTitleKey: "titlerightA0",
    rightTextKey: "textrightA0",
    rightTitle1Key: "titleright1",
    rightText1Key: "textrightA1",
  },
  {
    id: "Sokoban",
    route: "/Sokoban",
    titleKey: "projecttitle5",
    descriptionKey: "project5",
    techs: "Java",
    categories: ["Java"],
    github: "https://github.com/julienlrzl/Sokoban",
    image: sokobanImg,
    year: "2024",
    languages: ["Java"],
    tools: null,
    team: [
      { name: "Julien Larzul", github: "https://github.com/julienlrzl" },
      { name: "Loïc Plasse", github: "https://github.com/Loic-Plasse" },
    ],
    rightTitleKey: "titlerightS0",
    rightTextKey: "textrightS0",
    rightTitle1Key: "titleright1",
    rightText1Key: "textrightS1",
  },
  {
    id: "Ptut",
    route: "/Ptut",
    titleKey: "projecttitle2",
    descriptionKey: "project2",
    techs: "React.js .NET",
    categories: ["Web"],
    github: "https://github.com/julienlrzl/Projet_Tutore",
    image: ptutImg,
    year: "2023",
    languages: ["HTML", "CSS", "Javascript", ".Net", "SQL"],
    tools: ["React.js", "Git"],
    team: [
      { name: "Julien Larzul", github: "https://github.com/julienlrzl" },
      { name: "Cédric Momprivé", github: "https://github.com/Majriche" },
      { name: "Tom Toupence", github: "https://github.com/Freedqumm" },
      { name: "Albin Martin", github: "https://github.com/Albin0903" },
      { name: "Alexandre Le" },
    ],
    rightTitleKey: "titlerightP0",
    rightTextKey: "textrightP0",
    rightTitle1Key: "titleright1",
    rightText1Key: "textrightP1",
  },
  {
    id: "Connect4",
    route: "/Connect4",
    titleKey: "projecttitle4",
    descriptionKey: "project4",
    techs: "Java",
    categories: ["Java"],
    github: null,
    image: connect4Img,
    year: "2022",
    languages: ["Java"],
    tools: null,
    team: [
      { name: "Julien Larzul", github: "https://github.com/julienlrzl" },
    ],
    rightTitleKey: "titlerightC0",
    rightTextKey: "textrightC0",
    rightTitle1Key: "titleright1",
    rightText1Key: "textrightC1",
  },
];

export default projectsData;
